

const accessRestricted = "Access restricted";

export const BrowserTitles = {
  Login: "Login",
  ContactUs: "Contact us",
  Home: "Home",
  MemberOffers:"Member offers",
  CustomerOffers: "Customer offers",
  GPAppointments247: "GP appointments 24/7",
  Check4Cancer: "Check4Cancer",
  HealthSupport: "Health support",
  HealthSupportHub: "Health Hub",
  HealthInfo: "Health information",
  ChooseYourPlan: "Choose a membership",
  Timeout: "Time out",
  PageNotFound: "Page not found",
  Locked: "Account locked",
  TimeSettings: "Check time settings",
  OnlineAccessUnavailable: "Online access unavailable",
  PolicyLocked: "Access locked",
  RestrictedPolicy: accessRestricted,
  RestrictedGroup: accessRestricted,
  RestrictedUser: accessRestricted,
  GenericError: "Error",
  Cover: "Cover details",
  MakeChangesToCover: "Make changes to cover",
  MembershipInfo: "Membership documents",
  Renewal: "My renewal",
  Claims: "My claims",
  MakeAClaim: "Make a claim",
  HowToClaim: "How to claim",
  ClaimDetails: "Claim details",
  PaymentDetails: "Payment details",
  MedicalConsent: "Medical consent",
  PersonConsent: "My marketing preferences",
  CommunicationPreferences: "My Communication preferences",
  ContactPreferences: "My Contact preferences",
  HomeCommunicationPreference: "Communication support options",
  HomeCommunicationSupportNeeds: "Communication support needs",
  HomeContactPreference: "Contact preferences",
  MyProfile: "Personal details",
  MyProfileContactPreferences: "Communication settings",
  Permissions: "Permissions",
  CommunicationPreference:"Communication needs",
  ChangePhoneNumber: "Change my phone number",
  ChangeAddress: "Change my address",
  ChangeBankDetails:"Change my Bank Account",
  Help: "Help",
  AddAPlan: "Add a new membership number",
  CoverDocuments: "Membership documents",
  Renewals: "Renewal documents",
  // WorkingBody: "Speak to a physiotherapist",
  WorkingBody: "muscles, bones and joints service",
  AskAMedicalExpert: "Ask a medical expert",
  FastTrack: "Specialist Appointment Booking Service",
  FastTrackAppointmentDetails: "Appointment details",
  Inbox: "Inbox",
  InternalView: "Internal View",
  Notifications: "Notifications",
  SystemUnavailable: "Site Unavailable",
  ProactiveHeathGateway: "Proactive Health Gateway",
  LoggedOut: "Logged out",
  LogoutRedirect: "Logout redirect",
  MemberDetails: "Member details",
  DocumentPreference: "Document preference",
  Check4CancerProstate : "Prostate diagnostic service",
  CancerDiagnosticServices : "Cancer diagnostic services",
  Check4CancerSkin : "Skin diagnostic service",
  Check4CancerBreast : "Breast diagnostic service"
};
